import { useCallback } from "react";
import { useSwitchOrganization } from "./useSwitchOrganization";

export const useOrganizationActions = (pathname: string, search: string) => {
  const { switchOrganization, isSwitching, destination } = useSwitchOrganization(pathname, search);

  const dispatchSwitchOrganization = useCallback(
    async (organizationId: string | number) => {
      try {
        return await switchOrganization(organizationId);
      } catch {
        return;
      }
    },
    [switchOrganization],
  );

  return {
    switchOrganization: dispatchSwitchOrganization,
    isSwitching,
    destination,
  };
};
